import React from "react";
import { createUseStyles } from "$utils/createUseStyles";
import clsx from "clsx";
import {
  Button as UiButton,
  ButtonProps as MUIButtonProps,
} from "@mui/material";
import ConfirmWrap from "./ConfirmWrap";
import { theme } from "$utils/theme/bataillog";

export type ButtonProps = {
  color?: "primary" | "secondary" | "default";
  isDefault?: boolean;
  children?: React.ReactNode;
  padding6?: boolean;
  link?: boolean;
  confirm?: boolean;
  confirmMessage?: string;
  confirmOk?: string;
  confirmCancel?: string;
} & MUIButtonProps;

const Button = React.forwardRef(
  (
    {
      color = "primary",
      className = "",
      isDefault = false,
      padding6 = false,
      link,
      confirm = false,
      confirmMessage = "Êtes-vous sûr ?",
      confirmOk = "Confirmer",
      confirmCancel = "Annuler",
      ...otherProps
    }: ButtonProps,
    ref: any
  ) => {
    const classes = useStyles();
    const variant = color === "primary" ? "contained" : "text";
    const newcolor =
      color === "primary" || color === "secondary" ? "primary" : "default";
    const customProps = {} as any;
    if (!isDefault) {
      customProps.color = newcolor;
    }

    const btn = (
      <UiButton
        className={clsx(
          classes.button,
          className,
          padding6 && classes.p6,
          link ? "link" : ""
        )}
        disableElevation
        variant={variant}
        ref={ref}
        // {...customProps}
        {...otherProps}
      />
    );

    if (confirm) {
      return (
        <ConfirmWrap
          message={confirmMessage}
          labelOk={confirmOk}
          labelCancel={confirmCancel}
        >
          {btn}
        </ConfirmWrap>
      );
    }
    return btn;
  }
);

const useStyles = createUseStyles(() => ({
  button: {
    "&.MuiButton-containedPrimary": {
      backgroundColor: theme.color.blueLight,
      "&:hover,&:focus": {
        backgroundColor: theme.color.blueLighter,
      },
      "&.Mui-disabled": {
        backgroundColor: "#e0e0e0",
        color: "#9e9e9e",
      },
    },
    "&.MuiButton-textPrimary": {
      border: `1px solid ${theme.color.blueLight}`,
      color: theme.color.blueLight,
      "&:hover,&:focus": {
        backgroundColor: theme.color.blueLight,
        color: theme.color.white,
      },
      "&.Mui-disabled": {
        border: "1px solid #e0e0e0",
        color: "#9e9e9e",
        backgroundColor: "transparent",
      },
    },
    "&.MuiButton-root": {
      textTransform: "initial",
    },
    "& .remixicon-icon": {
      height: 16,
    },
    "&.MuiButton-text .remixicon-icon": {
      height: 16,
      marginRight: 5,
    },
    "&.link": {
      border: 0,
      color: theme.color.black,
      "&.MuiButton-textPrimary:hover, &.MuiButton-textPrimary:focus": {
        backgroundColor: theme.color.white,
        color: theme.color.black,
      },
      "&.Mui-disabled": {
        color: "#9e9e9e",
      },
    },
  },
  p6: {
    "&.MuiButton-root": {
      padding: 6,
    },
  },
}));

export default Button;
